export default "__VITE_ASSET__9ce43698__"